<template>
<div class="report-ring-chart">
  <div class="report-ring-chart-wrapper">
    <div class="report-ring-chart-inner">
      <e-chart ref="chart" />
    </div>
  </div>
  <div class="report-ring-chart-title">{{title}}</div>
</div>
</template>

<script>
import EChart from '../Charts/ECharts'

const chartConfig = {
  barMaxWidth: 35,
  // textFontFamily: 'STSong-Light',
  // textFontFamily: 'STSONG',
  // textFontFamily: '华文宋体',
  textFontFamily: '宋体',
  numberFontFamily: 'Times New Roman'
}

export default {
  name: 'ReportRingChart',
  components: {EChart},
  props: {
    title: {
      type: String
    },
    data: {
      required: true,
      type: Array
    }
  },
  methods: {
    render () {
      const chartOpt = {
        tooltip: {
          appendToBody: true
        },
        legend: {
          orient: 'vertical',
          top: 'middle',
          right: 0
        },
        series: [{
          name: 'ring',
          type: 'pie',
          // center: ['40%', '50%'],
          radius: ['40%', '70%'],
          label: {
            show: true,
            // position: 'inside',
            formatter: '{b}:{d}%',
            fontFamily: chartConfig.textFontFamily,
            color: '#000000'
          },
          data: this.data
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  },
  watch: {
    data () {
      this.render()
    }
  },
  mounted () {
    setTimeout(() => {
      this.render()
    }, 0)
  }
}
</script>

<style lang="scss" scoped>
.report-ring-chart {
  > .report-ring-chart-title {
    font-size: 14px;
    margin-bottom: .5em;
    text-align: center;
  }

  > .report-ring-chart-wrapper {
    position: relative;
    padding-bottom: 56.25%;

    > .report-ring-chart-inner {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReportChart/ReportRingChart.vue